export const getYearMonthDayFromDate = (dateOfBirth: string): number[] =>
  dateOfBirth.split("-").map((value) => parseInt(value, 10));

export const removeNOPrefix = (value: string): string =>
  value.replace(/^NO~/g, "");
